import Hero from './hero';
import WhatIsATrail from './what-is-a-trail';
import HowTrailsWork from './how-trails-work';
import ForGuides from './for-guides';
import ForSubscribers from './for-subscribers';
import FAQ from './faq';
import FinalCTA from './final-cta';
import FloatingClouds from './floating-clouds';
import Footer from '../../Footer';

export default function BogglerTrailsPage({
  waitlistUrl = '#',
  showFooter = true,
  logoSrc = '/boggler-logo.webp',
}) {
  return (
    <main className="relative overflow-hidden">
      <FloatingClouds />
      <Hero logoSrc={logoSrc} waitlistUrl={waitlistUrl} />
      <WhatIsATrail />
      <HowTrailsWork />
      <ForGuides />
      <ForSubscribers />
      <FAQ />
      <FinalCTA logoSrc={logoSrc} waitlistUrl={waitlistUrl} />

      {showFooter && (
        <Footer />
      )}
    </main>
  );
}
